import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';

/**
 * A modification to _.isEmpty for numbers. The _.isEmpty method doesn't return true if number > 0. https://github.com/lodash/lodash/issues/496
 * @param value {any} The value to check if empty
 */
export default (value) => (isNumber(value) ? isNil(value) : isEmpty(value));
